import Feature16_2 from './Feature16_2'
export default Feature16_2
